export class SubtradeChannel {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
    Inactive: boolean;
    SubtradeCategoryID?: number;
    IEI_Eligible: boolean;
    EnhancedPaymentOptions: boolean;
    AuthorizedMaterialList: string;
    DrPepperAuthorizedMaterialList: string;
    OffDayDeliveryFee: boolean;
    ClerkCode: string;
    ToleranceGroup: string;
}

export default SubtradeChannel;